import { Screen, Text } from "components"
import React, { useEffect, useState } from "react"
import { Animated, Dimensions, FlatList, Platform, View } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import MaterialIcons from "@expo/vector-icons/MaterialIcons"
import moment from "moment"
import LinearGradient from "react-native-linear-gradient"
import { translate } from "i18n"
import { useStores } from "models"
import { useSessionExpired } from "utils/function"
import { size } from "lodash"
import { colors } from "colors"
import useResponsiveWidth from "components/fitSize"
import { useColor } from "app/theme/getThemes"

export const PointHistoryScreen = () => {
  const { userStore } = useStores()
  const { companyTheme } = useColor()
  const navigation = useNavigation<any>()
  // const { width } = useWindowDimensions()

  const getResponsiveWidth = useResponsiveWidth()
  const { width } = getResponsiveWidth()

  const { sessionExpired } = useSessionExpired()

  const [maxHeight] = useState(110)
  const [minHeight] = useState(Platform.OS === "web" ? 60 : 55)
  const [scrollY] = useState(new Animated.Value(0))

  const [point, setPoint] = useState()
  const [pointHistory, setPointHistory] = useState()

  useEffect(() => {
    getUserPoint()
    getUserPointHistory()
  }, [])

  const getUserPoint = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointbal`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()
          setPoint(responseData?.data?.toLocaleString())
          userStore?.update({
            totalPoint: responseData?.data,
            // totalPoint: 9000,
          })
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const getUserPointHistory = async () => {
    await fetch(`${process.env.API_URL}/api/client/pointHistory`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${userStore?.accessToken}`,
      },
    })
      .then(async (res) => {
        if (res?.ok) {
          const responseData = await res?.json()

          // Sorting in descending order based on ID or a numeric field
          const sortedData = responseData?.data?.sort(
            (a: any, b: any) => moment(b?.created_at).valueOf() - moment(a?.created_at).valueOf(),
          )

          setPointHistory(sortedData)
        } else {
          const errorMsg = await res?.json()
          if (errorMsg?.error === "Token expired" || errorMsg?.error === "Invalid token") {
            sessionExpired()
          }
        }
      })
      .catch((e) => {
        console.error(e)
      })
  }

  const headerHeight = scrollY.interpolate({
    inputRange: [0, maxHeight - minHeight],
    outputRange: [maxHeight, minHeight],
    extrapolate: "clamp",
  })

  const bottomContentOpacity = scrollY.interpolate({
    inputRange: [0, (maxHeight - minHeight) / 2, maxHeight - minHeight],
    outputRange: [1, 1, 0],
    extrapolate: "clamp",
  })

  const topContentOpacity = scrollY.interpolate({
    inputRange: [0, (maxHeight - minHeight) / 2, maxHeight - minHeight],
    outputRange: [0, 0, 1],
    extrapolate: "clamp",
  })

  console.log(topContentOpacity)

  return (
    <Screen preset="fixed">
      <View
        style={[
          style.container,
          {
            paddingTop: headerHeight ? maxHeight : 0,
            ...(Platform.OS === "web" ? { height: "100%" } : {}),
          },
        ]}
      >
        <View style={{ height: "100%" }}>
          <FlatList
            showsVerticalScrollIndicator={false}
            scrollEventThrottle={16}
            onScroll={Animated.event([{ nativeEvent: { contentOffset: { y: scrollY } } }])}
            contentContainerStyle={{ marginBottom: 100 }}
            data={pointHistory}
            scrollEnabled={true}
            ListHeaderComponent={() => {
              return (
                size(pointHistory) > 0 && (
                  <Text style={style.pointContentTitle}>
                    {translate("pointHistoryScreen.pointTransactionHistory")}
                  </Text>
                )
              )
            }}
            ListEmptyComponent={() => {
              return (
                <View style={style.emptyContainer}>
                  <Text style={style.emptyTitleText}>
                    {translate("pointHistoryScreen.emptyTitle")}
                  </Text>
                  <Text>{translate("pointHistoryScreen.emptyDescription")}</Text>
                </View>
              )
            }}
            ListFooterComponent={() => {
              // List will be blocked by the bottom tab bar
              return <View style={style.bottomBlock} />
            }}
            ItemSeparatorComponent={() => {
              return <View style={style.separator} />
            }}
            renderItem={({ item }) => {
              const type = item?.credit > 0 ? "credit" : "debit"

              return (
                <View style={style.contentContainer}>
                  <View style={{ width: "80%" }}>
                    <View>
                      <Text numberOfLines={1}>{item?.description}</Text>
                    </View>

                    <Text style={style.expiredDateText}>
                      Date: {moment(item?.created_at).format("DD-MM-YYYY • HH:mm")}
                    </Text>

                    {item?.receipt_number && (
                      <Text style={[style.expiredDateText, { color: companyTheme.second }]}>
                        Rpt#: {item?.receipt_number}
                      </Text>
                    )}
                    {item?.expired_at && (
                      <Text style={[style.expiredDateText, { color: "red" }]}>
                        Expired on: {moment(item?.expired_at).format("DD-MM-YYYY • HH:mm")}
                      </Text>
                    )}
                  </View>
                  <Text
                    style={[
                      style.pointContentText,

                      type !== "credit" ? style.redText : style.greenText,
                    ]}
                  >
                    {type !== "credit" ? "-" : "+"}{" "}
                    {type !== "credit"
                      ? item?.debit?.toLocaleString()
                      : item?.credit?.toLocaleString()}{" "}
                    {translate("common.shortFormPoint")}
                  </Text>
                </View>
              )
            }}
          />
        </View>
      </View>

      <LinearGradient
        style={[style.linearGradient, { width }]}
        colors={[companyTheme.first, companyTheme.second]}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
      >
        <Animated.View style={[style.animatedViewContainer, { height: headerHeight }]}>
          <View style={style.headerContainer}>
            <View style={style.headerContentContainer}>
              <View style={style.headerIconContainer}>
                <MaterialIcons
                  name="chevron-left"
                  color="white"
                  size={38}
                  onPress={() => navigation.goBack()}
                />
              </View>

              <Animated.Text style={[{ opacity: topContentOpacity }, style.headerTopPointText]}>
                {point} {translate("common.shortFormPoint")}
              </Animated.Text>
            </View>

            <Animated.View
              style={[{ opacity: bottomContentOpacity }, style.headerBottomPointContainer]}
            >
              <Text style={style.headerBottomTitleText}>
                {translate("pointHistoryScreen.yourPoint")}
              </Text>
              <Text style={style.headerBottomPointText}>
                {point || 0} {translate("common.shortFormPoint")}
              </Text>
            </Animated.View>
          </View>
        </Animated.View>
      </LinearGradient>
    </Screen>
  )
}
